
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter4On as ObiFilter4OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-4-on.js';
 
 
 

 
 export const ObiFilter4On = createComponent({
   react: React,
   tagName: 'obi-filter-4-on',
   elementClass: ObiFilter4OnElement,
   events: {
     
   }
  });
 
 